export enum WinsPeriodStatusEnum {
  VALID = 'VALID',
  WINS_EXPIRED = 'WINS_EXPIRED',
  WINS_EXPIRING = 'WINS_EXPIRING',
}
